export const ROUTES = {
  HOME: "/",
  SIGNUP: "/signup",
  SIGNIN: "/signin",
  LOGOUT: "/logout",
  LIST_TRACTOR_OWNER: "/owner-list-tractor",
  // EQUPIMENT_LISTING: '/equipment-listing',
  // EQUPIMENT_LISTING_UPDATE: '/equipment-listing/:id',
  EQUPIMENT_LISTING: "/list-equipment",
  EQUPIMENT_LISTING_UPDATE: "/list-equipment/:id",

  TRACTOR_META: "/listing-config/:id",
  LISTING_IMAGES: "/listing-images/:id",
  ADD_ATTACHMENTS: "/attachments/:id",
  SET_PRICING: "/set-pricing",

  LISTING_OPTIONAL_SERVICE: "/listing/optional-service/:id",
  LISTING_USAGE_RATE: "/listing/usage-rate/:id",
  LISTING_DEPOSIT_PRICING_POLICY: "/listing/deposit-pricing-policy/:id",
  LISTING_ADDRESS: "/listing/address/:id",

  SELLER_CONFIG: "/seller-config/:id",

  // DASHBOARD: '/owner/dashboard',
  MANAGE_LISTING: "/listing",
  COMMUNICATION: "/owner/communication",
  DOCUMENTS: "/owner/documents",
  RENTALS: "/rental",
  SEARCH_LISTING: "/search-listing",
  LISTING_DETAIL: "/listing-detail/:id",
  VIEW_BOOKING: "/view-bookings",
  APPROVAL_POLICY: "/approval-policy",

  CART: "/cart",
  SAVED_ADDRESS: "/saved-address",

  PERSONAL_RENTAL: "/booking-history",
  MESSAGES: "/messages/:id",

  FORGOT_PASSWORD: "/forgot-password",
  OWNER_FAQS: "/faq/owners",
  RENTER_FAQS: "/faq/renters",

  HOW_IT_WORKS: "/how-it-works",
  PROFILE: "/profile",
  ABOUT_US: "/about-us",

  PAYMENT: "/payment",
  DASHBOARD: "/dashboard",
  RENTAL_HISTORY: "/rental",
  LISTING: "/listing",
  DOCUMENT: "/documents",
  BLOG: "/blogs",
  VIEW_BLOG: "/blogs/view",
};
